import React from 'react';
import Assistance from '../stepper/assistance';
import { Ticket } from '../svg/ticket';

const Title = ({ title }: { title: string }) => {
  return (
    <div className="flex flex-column justify-between items-center">
      <h2>
        <Ticket />{' '}
        <span className="text-xl" style={{ fontWeight: 'bold' }}>
          {title}
        </span>
      </h2>
      <Assistance />
    </div>
  );
};

export default Title;
